import { namespaceActions } from 'modules/redux-utils'
import { NAME } from './constants'

const RECALCULATE_RATING_AREAS = 'RECALCULATE_RATING_AREAS'
const RECALCULATE_RATING_AREAS_SUCCESS = 'RECALCULATE_RATING_AREAS_SUCCESS'
const RECALCULATE_RATING_AREAS_ERROR = 'RECALCULATE_RATING_AREAS_ERROR'

const actionTypes = namespaceActions(NAME)([
  RECALCULATE_RATING_AREAS,
  RECALCULATE_RATING_AREAS_SUCCESS,
  RECALCULATE_RATING_AREAS_ERROR,
])

export default actionTypes
export const {
  RECALCULATE_RATING_AREAS: t_RECALCULATE_RATING_AREAS,
  RECALCULATE_RATING_AREAS_SUCCESS: t_RECALCULATE_RATING_AREAS_SUCCESS,
  RECALCULATE_RATING_AREAS_ERROR: t_RECALCULATE_RATING_AREAS_ERROR,
} = actionTypes
